import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import mitt from 'mitt'
// // 防抖函数
// function debounce(fn: Function, delay: number): Function {
//   let timer: number | null = null;
//   return function (...args: any[]) {
//     if (timer) {
//       clearTimeout(timer);
//     }
//     timer = window.setTimeout(() => {
//       fn.apply(this, args);
//     }, delay);
//   };
// }

// // 重写 ResizeObserver
// const originalResizeObserver: typeof ResizeObserver = window.ResizeObserver;
// window.ResizeObserver = class extends originalResizeObserver {
//   constructor(callback: ResizeObserverCallback) {
//     const debouncedCallback = debounce((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
//       callback(entries, observer);
//     }, 300); // 防抖延迟时间设置为300毫秒
//     super(debouncedCallback);
//   }
// };

const app=createApp(App)
// 创建全局事件总线
const eventBus=mitt()
// 将事件总线添加到全局属性  
// app.config.globalProperties.$bus=eventBus
app.use(store).use(router).use(ElementPlus).mount('#app')
